import { SUBSCRIPTION_DISCOUNT_APPLY_FOR } from '@/modules/base/util/constants'
import store from '@/redux/store'

const checkDiscount = (subscriptionType: string, reducedPrice: { applyFor: keyof typeof SUBSCRIPTION_DISCOUNT_APPLY_FOR }): boolean => {
  const { subscription: { details: { subscriptions } } } = store.getState()

  const existingSubscription = subscriptions?.find((sub) => sub.typeOfSubscription === subscriptionType)
  const hasPremiumSubscription = existingSubscription && !existingSubscription?.isTrial

  if (!reducedPrice || !reducedPrice.applyFor) {
    return true
  }

  const { applyFor } = reducedPrice
  switch (applyFor) {
    case SUBSCRIPTION_DISCOUNT_APPLY_FOR.PROSPECT:
      return !hasPremiumSubscription
    case SUBSCRIPTION_DISCOUNT_APPLY_FOR.EXISTING_CUSTOMER:
      return hasPremiumSubscription
    default:
      return true
  }
}

export default checkDiscount
